videojs.addLanguage('fr', {
  "POPUP_EXPORT": {
    "color": "Couleur",
    "language": "Langage",
    "autoplay": "Autoplay",
    "from": "A partir de",
    "permalink": "Permalink",
    "embed": "Embed",
    "french": "Français",
    "english": "Anglais",
    "italian": "Italien",
    "spanish": "Espagnol"
  },
  "title_embed": "Le lien embed de la vidéo",
  "play_auto": "Démarrer la lecture automatiquement",
  "default_color": "Couleur par défaut de player",
  "start_play": "Démarrer la lecture à",
  "integration": "Intégration"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_exportShare/dist/lang/fr.js
// module id = 540
// module chunks = 39